import { Fragment } from "react";
import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import { objectToQueryString } from "membership-ui/login/utils/utils";
import { fetchNavbarAndFooter } from "lib/fetchers/common";

import { Breakfast } from "content-ui/breakfast/types";
import { fetchBreakfast } from "content-ui/breakfast/fetcher";
import BreakfastDetailView from "content-ui/breakfast/breakfastDetailView";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

export async function getServerSideProps({ res, params, preview = false }) {
  const [menuItems, pageData] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchBreakfast({ preview, slug: params.slug[0] }),
  ]);

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  if (!pageData) {
    // Show 404 page if no pageData is found
    return { notFound: true };
  }

  return {
    props: {
      pageData,
      canonical: buildCanonicalUrl(`/breakfast/${params.slug[0]}`),
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
  };
}

type BreakfastDetailPageProps = {
  pageData: Breakfast;
  canonical: string;
};

const BreakfastDetailPage = (props: BreakfastDetailPageProps) => {
  const { pageData } = props;

  const seoImage = `${pageData.seo.image.url}?${objectToQueryString({
    w: "1200",
    q: "75",
    auto: "format,compress",
  })}`;

  return (
    <Fragment>
      <Head>
        {generateNextSeo({
          canonical: props.canonical,
          openGraph: {
            title: pageData.seo.title,
            description: pageData.seo.description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <BreakfastDetailView {...pageData} />
      </ErrorBoundary>
      <Footer />
    </Fragment>
  );
};

export default BreakfastDetailPage;
